module.exports = __webpack_public_path__ + "static/media/o-Origin.f9fa66de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/o-Origin.png
// module id = 176
// module chunks = 0